export default "__VITE_ASSET__C_oL3DCq__"